import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './SkincareMainConcern.module.sass';
import Button from '../../../../ui_kit/button/Button';
import BackButton from '../../back_button/BackButton';
import CONCERNS from '../../../constants/concerns';
import Concern from './concern/Concern';

const MAX_CONCERNS_COUNT = 3;

function SkincareMainConcern(props) {
  const {
    increaseStep, decreaseStep, quiz, step,
  } = props;

  const [concerns, setConcerns] = useState(quiz.concerns);
  const [customConcern, setCustomConcern] = useState(
    concerns.find((concern) => !CONCERNS.includes(concern)) || '',
  );

  const onNextClick = () => {
    increaseStep({ ...quiz, concerns });
  };

  const onConcernClicked = (newConcern) => {
    if (concerns.includes(newConcern)) {
      setConcerns(concerns.filter((concern) => concern !== newConcern));
    } else if (concerns.length < MAX_CONCERNS_COUNT) {
      setConcerns([...concerns, newConcern]);
    }
  };

  const onCustomConcernChange = (updatedConcern) => {
    const newConcerns = concerns.filter((concern) => concern !== customConcern);
    setConcerns(newConcerns);
    if (newConcerns.length === MAX_CONCERNS_COUNT) { return; }

    setCustomConcern(updatedConcern);
    if (updatedConcern.length > 0) {
      setConcerns([...newConcerns, updatedConcern]);
    }
  };

  const { color } = quiz;

  const isCustomConcernEditable = () => concerns.includes(
    customConcern,
  ) || concerns.length < MAX_CONCERNS_COUNT;

  return (
    <>
      <BackButton decreaseStep={() => { decreaseStep({ ...quiz, concerns }); }} />
      <div className={styles['main-concern']}>
        <div className={styles.content}>
          {step}
          <h1 className={styles.title}>
            Let&apos;s learn about your main concern.
          </h1>
          <div className={styles.description}>
            {`Choose up to ${MAX_CONCERNS_COUNT}`}
          </div>
          <div className={styles.concerns}>
            {CONCERNS.map((concern) => (
              <Concern
                onClick={() => { onConcernClicked(concern); }}
                key={concern}
                concern={concern}
                isActive={concerns.includes(concern)}
                color={color}
              />
            ))}
            <Concern
              onChange={onCustomConcernChange}
              concern={isCustomConcernEditable() ? customConcern : 'Other, Type Here'}
              className={!isCustomConcernEditable() ? styles.disabled : null}
              editable={isCustomConcernEditable()}
              isActive={concerns.includes(customConcern)}
              color={color}
            />
          </div>
          <Button
            className={`${styles.button} custom-transparent-button`}
            onClickHandler={onNextClick}
            disabled={concerns.length === 0}
            text="NEXT"
            color="transparent-blue"
            size="small"
          />
        </div>
      </div>
    </>
  );
}

SkincareMainConcern.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  quiz: PropTypes.shape({
    concerns: PropTypes.arrayOf(PropTypes.string),
    color: PropTypes.string,
  }).isRequired,
  step: PropTypes.node.isRequired,
};

export default SkincareMainConcern;
